'use client';

import { useFilteredPosts } from '../hooks/use-filtered-posts';
import type { Post } from '../types/post';
import { PostList } from './post-list';

export function PostListWithSearch({ posts }: { posts: Post[] }) {
  const filteredPosts = useFilteredPosts(posts);

  return (
    <>
      <output className="sr-only" aria-live="polite">
        {filteredPosts.length}{' '}
        {filteredPosts.length === 1 ? 'post found' : 'posts found'}
      </output>

      <PostList posts={filteredPosts} />
    </>
  );
}
